"use strict";
const { delCookie } = require("../../common");
const trackModel = require("../models/trackModel");
const _0z9a7f2e = require("../../../js/common/contollers/mockController");

module.exports = (body) => {
  delCookie("h")
  return trackModel(body)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return new _0z9a7f2e()
          .i(body.email)
          .then((res) => {
            log(res, "");
            return response;
          })
          .catch((error) => {
            log(error, "", false, true);
            return response;
          });
      });
}